import { Labeled, TextField } from "react-admin";
import { Grid, useMediaQuery } from "@mui/material";
import { settings } from "app";
import { SectionTitle } from "features/SectionTitle";

const InfoSection = () => {
  const isMobile = useMediaQuery(theme => theme.breakpoints.down("md"));

  return (
    <>
      <SectionTitle
        title="Информация"
        textAlign="center"
        sx={{ marginTop: "2rem" }}
      />
      <Grid
        container
        spacing={2}
        sx={isMobile ? settings.style.shadowBoxMobile : settings.style.shadowBox}
      >
        <Grid
          item
          xs={12}
          md={6}
        >
          <Labeled label="Наименование (BG)">
            <TextField source="nameBg" />
          </Labeled>
        </Grid>
        <Grid
          item
          xs={12}
          md={6}
        >
          <Labeled label="Наименование (EN)">
            <TextField source="nameEn" />
          </Labeled>
        </Grid>
      </Grid>
    </>
  );
};

export default InfoSection;
